import classnames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import * as styles from './CharacterCount.css';

const cx = classnames.bind(styles);

export interface CharacterCountProps {
    testId?: string;
    className?: string;
    limit: number;
    value: number;
}

export function CharacterCount({ testId, className, value, limit }: CharacterCountProps) {
    const { t } = useTranslation();
    const over = value > limit;
    const classes = cx('base', { over }, className);
    const count = Math.abs(limit - value);
    const context = value === 0 ? undefined : over ? 'over' : 'under';

    return (
        <div data-testid={testId} className={classes}>
            {t('components:CharacterCount.message', { count, limit, context })}
        </div>
    );
}
